import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
import moment from 'moment';
import salesReportFragment from '../../fragments/salesReport/salesReportInfo';
import correctedSalesReportFragment from '../../fragments/salesReport/correctedSalesReportInfo';
export const getSalesReportQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getSalesReport($startDate: String, $endDate: String) {\n    salesReport(startDate: $startDate, endDate: $endDate) {\n      ...salesReportInfo\n    }\n    correctedSalesReport(startDate: $startDate, endDate: $endDate) {\n      ...correctedSalesReportInfo\n    }\n  }\n  ", "\n  ", "\n"])), salesReportFragment, correctedSalesReportFragment);
export const getSalesReportQueryOptions = variables => ({
  variables: {
    startDate: variables.startDate ? moment(variables.startDate).format('YYYY-MM-DD') : null,
    endDate: variables.endDate ? moment(variables.endDate).format('YYYY-MM-DD') : null
  },
  fetchPolicy: 'no-cache'
});